(function () {
  function pad2(n) { return String(n).padStart(2, '0'); }

  function updateCountdown(el, unlockTs) {
    var now = Math.floor(Date.now() / 1000);
    var diff = unlockTs - now;
    if (diff <= 0) return true;

    // Add "soon" state when under 24 hours
    var card = el.closest('.ihs-release-message');
    if (card) {
      card.classList.toggle('ihs-release-soon', diff <= 86400);
    }

    var days = Math.floor(diff / 86400);
    diff -= days * 86400;
    var hours = Math.floor(diff / 3600);
    diff -= hours * 3600;
    var minutes = Math.floor(diff / 60);
    var seconds = diff - minutes * 60;

    var d = el.querySelector('[data-days]');
    var h = el.querySelector('[data-hours]');
    var m = el.querySelector('[data-minutes]');
    var s = el.querySelector('[data-seconds]');

    if (d) d.textContent = days;
    if (h) h.textContent = pad2(hours);
    if (m) m.textContent = pad2(minutes);
    if (s) s.textContent = pad2(seconds);

    return false;
  }

  function getGuardData() {
    var guard = document.querySelector('.ihs-release-guard');
    if (!guard || !guard.dataset) return null;

    var locked = guard.dataset.releaseLocked === 'true';
    var soldOut = guard.dataset.releaseSoldOut === 'true';

    // unlockTs is only required when locked
    var unlockTsRaw = guard.dataset.releaseUnlockTs || '';
    var unlockTs = parseInt(unlockTsRaw, 10);
    if (Number.isNaN(unlockTs)) unlockTs = null;

    return {
      locked: locked,
      soldOut: soldOut,
      unlockTs: unlockTs
    };
  }

  function initCountdown() {
    var data = getGuardData();
    if (!data) return false;

    // Toggle body classes to control hiding via CSS
    document.body.classList.toggle('ihs-release-locked', data.locked);
    document.body.classList.toggle('ihs-release-soldout', data.soldOut);

    // Only run countdown if locked and unlockTs is present
    if (!data.locked || !data.unlockTs) return true;

    var countdownEls = document.querySelectorAll('[data-ihs-countdown]');
    countdownEls.forEach(function (countdown) {
      // Avoid stacking multiple intervals
      if (countdown.__ihsTimer) return;

      var tick = function () {
        var done = updateCountdown(countdown, data.unlockTs);
        if (done) window.location.reload();
      };

      tick();
      countdown.__ihsTimer = window.setInterval(tick, 1000);
    });

    return true;
  }

  function initWithRetries() {
    var attempts = 0;
    var maxAttempts = 12; // ~3s
    var timer = window.setInterval(function () {
      attempts += 1;
      var ok = initCountdown();
      if (ok || attempts >= maxAttempts) window.clearInterval(timer);
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', initWithRetries);
  document.addEventListener('shopify:section:load', initWithRetries);
})();

